import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderOrgConponent from "../components/HeaderOrg";

 const PrivateRoute = ({ component: Component, ...rest }) => {
     const token = useSelector((state) => state.auth.token) || localStorage.getItem("token");
  const isAuthenticated = Boolean(token);
    return (
    <Route
      {...rest}
      render={(props) =>
        rest.private ? (
          isAuthenticated ? (
            <>
              {rest.name?.header && <HeaderOrgConponent {...props} {...rest} />}
              <Component {...props} />
            </>
          ) : (
            <Redirect to="/" /> // Redirect to main page if not logged in
          )
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRoute;